module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraBoldItalic.0c93713.woff";